import request from '@/utils/request'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'

export function getFrontInformationNote(data,param) {
   const url = handlerGetUrlParams('/bus/news_center/home/list', param)
  return request({
    url,
    method: 'POST',
    data
  })
}

export function getInformationNote(data) {
  return request({
    url: '/bus/news_center/list',
    method: 'POST',
    data
  })
}
export function updateStatus(data) {
  return request({
    url: 'bus/news_center/batch_update_status',
    method: 'PUT',
    data
  })
}
// 系统管理政策文件全部获取
export function getSystemPolicyDocumentList(data) {
  return request({
    url: `/bus/policy/list`,
    method: 'POST',
    data
  })
}
// 中心规则详情获取
export function getZXGZDetail(id) {
  return request({
    url: `/bus/central_regulation/info/${id}`,
    method: 'GET'
  })
}
// 修改政策文件状态
export function updatePolicyStatus(data) {
  return request({
    url: 'bus/policy/batch_update_status',
    method: 'PUT',
    data
  })
}
// 删除政策文件
export function deletePolicyNote(params) {
  return request({
    url: `/bus/policy/${params}`,
    method: 'DELETE'
  })
}

export function deleteInformationNote(params) {
  return request({
    url: `/bus/news_center/${params}`,
    method: 'DELETE'
  })
}

export function queryInformationNote(id) {
  return request({
    url: `bus/news_center/info/${id}`,
    method: 'GET'
  })
}

export function addInformationNote(data) {
  return request({
    url: `/bus/news_center`,
    method: 'POST',
    data
  })
}

export function updateInformationNote(data) {
  return request({
    url: `/bus/news_center`,
    method: 'PUT',
    data
  })
}

// 前台政策文件获取
export function getPolicyList(data = {}, pagination = '') {
  return request({
    url: `/bus/policy/home/list?${pagination}`,
    method: 'POST',
    data
  })
}

// 前台政策文件详情
export function getPolicyDetail(id = '') {
  return request({
    url: `/bus/policy/info/${id}`,
    method: 'GET'
  })
}

// 后台政策文件添加
export function addPolicyDocument(data) {
  return request({
    url: `/bus/policy`,
    method: 'POST',
    data
  })
}

// 后台政策文件删除
export function deletePolicyDocument(param) {
  return request({
    url: `bus/policy/${param}`,
    method: 'DELETE'
  })
}

// 政策文件后台编辑更新
export function editPolicyDocument(data) {
  return request({
    url: `bus/policy`,
    method: 'PUT',
    data
  })
}

// 政策文件后台详情
export function policyDocumentDetail(id) {
  return request({
    url: `bus/policy/info/${id}`
  })
}
